import React from 'react';
import { BeLogo } from './BeLogo';
export const CreditCard = ({
  className = ''
}: {
  className?: string;
}) => {
  return <div className={`bg-be-pink rounded-2xl p-6 shadow-xl flex flex-col justify-between relative overflow-hidden ${className}`} style={{
    width: '280px',
    height: '180px'
  }} data-id="element-88">
      {/* Subtle gradient overlay for depth */}
      <div className="absolute inset-0 bg-gradient-to-br from-white/20 to-transparent pointer-events-none" data-id="element-89"></div>

      <div className="relative z-10" data-id="element-90">
        <p className="text-white/90 text-xs font-bold tracking-[0.2em] uppercase mb-1" data-id="element-91">
          First-Visit Reset
        </p>
        <div className="flex items-start" data-id="element-92">
          <span className="text-white text-3xl font-bold mt-2 mr-1" data-id="element-93">$</span>
          <span className="text-white text-7xl font-bold leading-none tracking-tighter" data-id="element-94">
            150
          </span>
        </div>
      </div>

      <div className="relative z-10 flex justify-between items-end w-full" data-id="element-95">
        <p className="text-white font-bold tracking-[0.2em] text-sm uppercase" data-id="element-96">
          Credit
        </p>
        <BeLogo variant="white" className="h-10 w-auto opacity-95" data-id="element-97" />
      </div>
    </div>;
};